import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-24 px-4 bg-navy-800 relative border-y border-white/5" data-id="element-130">
      <div className="max-w-3xl mx-auto" data-id="element-131">
        <FadeIn data-id="element-132">
          <div className="prose prose-lg prose-invert mx-auto" data-id="element-133">
            <p className="text-2xl leading-relaxed text-slate-200 font-medium mb-8" data-id="element-134">
              Estás atrapado en un ciclo que parece no tener fin. Tienes el
              talento, tienes la disciplina y tienes una conexión a internet.
              Sin embargo, cada vez que intentas dar el salto al mercado global,
              te chocas contra el mismo muro:{' '}
              <span className="text-accent-400 font-bold" data-id="element-135">
                "Buscamos a alguien con experiencia internacional".
              </span>
            </p>

            <p className="text-xl text-slate-400 mb-12" data-id="element-136">
              ¿Cómo vas a tener esa experiencia si nadie te da la primera
              oportunidad? Mientras tanto, ves pasar los meses con un sueldo
              local que se desvanece frente a la inflación, sabiendo que a pocos
              miles de kilómetros alguien hace tu mismo trabajo por el triple de
              ingresos.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-137">
          <div className="bg-navy-900 p-8 md:p-10 rounded-2xl border border-red-500/10 shadow-[0_0_30px_rgba(239,68,68,0.05)]" data-id="element-138">
            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-139">
              El problema no es tu capacidad técnica.
            </h2>
            <p className="text-lg text-slate-300 mb-6" data-id="element-140">
              El problema es que estás intentando venderle a empresas de Estados
              Unidos o Europa usando las reglas de tu mercado local.
            </p>
            <p className="text-lg text-slate-300" data-id="element-141">
              Cuando envías un CV diseñado para una empresa de tu ciudad a un
              reclutador en Silicon Valley o Madrid, hueles a{' '}
              <strong className="text-red-400" data-id="element-142">"riesgo"</strong>. Ellos temen
              que no sepas autogestionarte, que tu internet falle o que
              necesites supervisión constante. Ante la duda, prefieren
              ignorarte. No te rechazan por falta de talento,{' '}
              <span className="text-white font-semibold border-b border-accent-500/50 pb-0.5" data-id="element-143">
                te rechazan porque tu perfil genera fricción operativa.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}